<template>
    <div class="row align-items-center justify-content-center" style="min-height: 100vh">
        <div class="col-12 col-md-8 col-xl-6">
               <LocaleSelect :vertical="collapsed" />
            <Card>
                <h5 class="font-weight-bold mb-heading">{{ __('Register') }}</h5>

                <div class="row">
                    <div class="col-lg-6 col-12">
                        <FormInput
                            :label="__('First name')"
                            name="first_name"
                            type="text"
                            v-model="user.firstname"
                            v-validate="'required'"
                        />

                        <FormInput
                            :label="__('Company code or VAT')"
                            name="company_code"
                            type="text"
                            v-model="user.companyCode"
                            v-validate="'required|min:9'"
                        />

                        <FormInput
                            :label="__('Email')"
                            name="email"
                            type="email"
                            v-model="user.email"
                            v-validate="'required|email'"
                        />

                        <FormInput
                            class="form-input-password"
                            :class="{'is-danger': errors.has('password')}"
                            :label="__('Password')"
                            name="password"
                            ref="password"
                            type="password"
                            v-model="user.password"
                            v-validate="'required|min:6'"
                        />
                    </div>

                    <div class="col-lg-6 col-12">
                        <FormInput
                            :label="__('Last name')"
                            name="last_name"
                            type="text"
                            v-model="user.lastname"
                            v-validate="'required'"
                        />

                        <FormInput
                            :label="__('Role')"
                            name="role"
                            type="text"
                            v-model="user.role"
                            v-validate="'required'"
                        />

                        <FormInput
                            :label="__('Phone')"
                            name="phone"
                            type="tel"
                            v-model="user.phone"
                            v-validate="{ required: true, regex: /^[0-9\s\+]*$/ }"
                        >
                            <template slot="prepend">
                               <!-- <div class="input-group-prepend">
                                    <span class="input-group-text">+370</span>
                                    </div> -->
                            </template>
                        </FormInput>

                        <FormInput
                            class="form-input-password"
                            :class="{'is-danger': errors.has('password_confirmation')}"
                            :label="__('Password repeat')"
                            data-vv-as="password"
                            name="password_confirmation"
                            type="password"
                            v-model="user.password2"
                            v-validate="'required|confirmed:password'"
                        />
                    </div>
                </div>
            </Card>

            <div class="card-after">
                <router-link
                    class="btn btn-secondary btn-sm w-25"
                    to="/login"
                >
                    {{ __('Back') }}
                </router-link>

                <button
                    @click.prevent="register"
                    class="btn btn-primary btn-sm w-25"
                >
                    {{ __('Register') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import User from '../../models/User'
import LocaleSelect from '../../plugins/LocaleSelect'

export default {
  name: 'Register',
 components: { LocaleSelect},
  data () {
    return {
      user: new User({})
    }
  },

  methods: {
    register () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          this.$api.auth.register(this.user)
            .then(() => {
              this.$router.push('/registersuccess')
            })
            .catch((response) => {
              this.setErrorsFromResponse(response)
            })
        }
      })
    }
  }
}
</script>
